// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hide-cursor{
    caret-color: transparent !important;
}

.disabled_input{
    background-color: #fdfdfd !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/Users/EditUser/EditUser.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;AACvC;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":[".hide-cursor{\n    caret-color: transparent !important;\n}\n\n.disabled_input{\n    background-color: #fdfdfd !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
